import { useEffect, useRef, useState } from 'react'

import { useRouter } from 'next/router'
import styled from 'styled-components'

import { buildPassTheme } from 'src/styles/theme'

const BG = buildPassTheme.colour.neutral.surface

const ProgressWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 6px;
  z-index: 10000;

  ${({ theme: { media } }) => media.md`
    height: 3px;
  `}
`

const ProgressBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: ${({ theme }) => theme.colour.secondary.base};
  transition: 0.3s;
  transition-timing-function: ease-in-out;
`

export const CorePageProgress = () => {
  const router = useRouter()
  const timeout50 = useRef<NodeJS.Timeout>(undefined)
  const timeout80 = useRef<NodeJS.Timeout>(undefined)
  const increment = useRef<NodeJS.Timeout>(undefined)
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const sendStart = (_, options) => {
      if (options?.shallow) return

      setProgress(0)
      timeout50.current = setTimeout(() => setProgress(40), 100)
      timeout80.current = setTimeout(() => setProgress(80), 500)
      increment.current = setInterval(() => {
        setProgress((p) => Math.min(p + 1, 96))
      }, 500)
    }

    const sendFinish = (_, options) => {
      if (options?.shallow) return

      clearTimeout(timeout50.current)
      clearTimeout(timeout80.current)
      clearInterval(increment.current)
      setProgress(100)
      setTimeout(() => setProgress(null), 500)
    }

    router.events.on('routeChangeStart', sendStart)
    router.events.on('routeChangeError', sendFinish)
    router.events.on('routeChangeComplete', sendFinish)

    return () => {
      router.events.off('routeChangeStart', sendStart)
      router.events.off('routeChangeError', sendFinish)
      router.events.off('routeChangeComplete', sendFinish)
    }
  }, [router])

  if (progress === null) {
    return null
  }

  return (
    <ProgressWrapper style={{ background: progress ? BG : 'transparent' }}>
      <ProgressBar style={{ width: `${progress}%` }} />
    </ProgressWrapper>
  )
}
